import { render, staticRenderFns } from "./successUnsubscribe.vue?vue&type=template&id=2b17b308&scoped=true&"
import script from "./successUnsubscribe.vue?vue&type=script&lang=ts&"
export * from "./successUnsubscribe.vue?vue&type=script&lang=ts&"
import style0 from "./successUnsubscribe.vue?vue&type=style&index=0&id=2b17b308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b17b308",
  null
  
)

export default component.exports